import type { LessonBadgeConfig } from '../model/types/learning-plan/interfaces'
import type { LessonBadgeColor, LessonBadgeType } from '../model/types/learning-plan/types'

import { LearningPlanCustomLessonType, LearningPlanLessonType } from '../model/types/learning-plan/enums'

const FALLBACK_BADGE_COLOR: LessonBadgeColor = 'indigo-400'

const LESSON_BADGES: Record<LessonBadgeType, LessonBadgeConfig> = {
  [LearningPlanLessonType.CoreMath]: { label: 'Core Math', color: 'indigo-400' },
  [LearningPlanLessonType.CoreEla]: { label: 'Core ELA', color: 'blue-400' },
  [LearningPlanLessonType.Homework]: { label: 'Homework', color: 'emerald-500' },
  [LearningPlanLessonType.FunPractice]: { label: 'Fun Practice', color: 'pink-400' },
  [LearningPlanLessonType.Assessment]: { label: 'Assessment', color: 'blue-400' },
  [LearningPlanLessonType.WrapUp]: { label: 'Wrap-Up', color: 'orange-400' },
  [LearningPlanLessonType.AlgebraOne]: { label: 'Algebra I', color: 'indigo-400' },
  [LearningPlanLessonType.AlgebraTwo]: { label: 'Algebra II', color: 'indigo-400' },
  [LearningPlanLessonType.Geometry]: { label: 'Geometry', color: 'pink-400' },
  [LearningPlanLessonType.Precalculus]: { label: 'Precalculus', color: 'blue-400' },
  [LearningPlanCustomLessonType.HomeworkHelp]: { label: 'Homework help', color: 'emerald-500' },
  [LearningPlanCustomLessonType.TestPreparation]: { label: 'Test preparation', color: 'indigo-400' },
  [LearningPlanCustomLessonType.Custom]: { label: 'Custom', color: 'amber-400' },
}

const toTitleCase = (value: string): string => {
  return value
    .split('_')
    .filter(Boolean)
    .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`)
    .join(' ')
}

export const getLessonBadge = (type: LessonBadgeType): LessonBadgeConfig => {
  return LESSON_BADGES[type] ?? { label: toTitleCase(type), color: FALLBACK_BADGE_COLOR }
}
